import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import {
  formatMoneyString as formatMoneyStringLib,
  formatMoney as formatMoneyLib,
  getCurrencySymbol,
} from "@scrile/tools/dist/lib/MoneyHelpers";
import { $t } from "@/lib/i18nHelpers";
import { getLocale } from "@/lib/localeHelper";
export { getCurrencySymbol } from "@scrile/tools/dist/lib/MoneyHelpers";
import config from "@/config";

export function printCredits(amount: string | number, currencyCode?: string) {
  if (typeof amount === "string") return $t("{0} Cr", [amount]);
  const moneyParts = formatMoneyLib(amount, { currencyCode });
  return $t("{0} Cr", [`${moneyParts.wholePart}${moneyParts.separator}${moneyParts.fractionalPart}`]);
}

interface FormatMoneyOpts {
  currencyCode?: string;
  forceNumberSymbol?: boolean;
}

export function formatMoney(amount: number, { currencyCode, forceNumberSymbol = false }: FormatMoneyOpts = {}) {
  return formatMoneyLib(amount, {
    currencyCode,
    locale: getLocale(),
    creditsSymbolTranslator: $t,
    useGrouping: config.moneyUseGrouping,
    forceNumberSymbol,
  });
}

export function formatMoneyString(amount: number, { currencyCode, forceNumberSymbol = false }: FormatMoneyOpts = {}) {
  return formatMoneyStringLib(amount, {
    currencyCode,
    locale: getLocale(),
    creditsSymbolTranslator: $t,
    useGrouping: config.moneyUseGrouping,
    forceNumberSymbol,
  });
}

export function getCost(pricePackage: PaymentPackage): number {
  return pricePackage.amount;
}

export function getMainCurrencyCode() {
  return "USD";
}

export function getCurrentPaymentSystem(systems: PaymentSystemPublic[], currency: string) {
  const system = systems.find(publicSystem => publicSystem.currencies.includes(currency));
  if (!system) throw new Error("System not found");
  return system;
}

export function getShrinkedNumber(value: number): string {
  if (value > 999999) return `${Math.floor(value / 1000000)}M`;
  if (value > 999) return `${Math.floor(value / 1000)}K`;
  return `${value}`;
}

export function printPaymentPackageName(name: string) {
  return name ? `${name}, ` : "";
}

export function printPaymentPackage(paymentPackage: PaymentPackage) {
  return `${printPaymentPackageName(paymentPackage.name)}${printCredits(paymentPackage.amount)}`;
}

export function getCostByCurrency(p: PaymentPackage, currency: string = getMainCurrencyCode()) {
  return p.costs.find(i => i.currency === currency);
}

export function printCost(cost: number, currencyCode = getMainCurrencyCode()) {
  const { fractionalPart, separator, wholePart, symbol } = formatMoney(cost, { currencyCode });
  return `${symbol}${wholePart}${separator}${fractionalPart}`;
}
